<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">

        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box">
            <EmdBoxHeader :title="$t('breadcrumb.edit.security')">
              <button class="emd-btn _color_secondary _type_text" v-show="disabled" @click="disabled = !disabled">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedback">
                <p>{{$t('edit.form.security.success_message')}}</p>
              </div>
              <error-list :items="errors"></error-list>
              <form ref="formSecurity" @submit.prevent="saveSecurity" novalidate="true">
                <fieldset>
                  <div class="emd-flex _direction_column _direction_row_md">
                    <div class="emd-flex-item _basis_12 _basis_6_md">
                      <div v-if="hosts.length > 0">
                        <div class="emd-chunk" v-for="(host, index) in hosts" :key="index">
                          <label class="emd-label" :for="`ip${index}`">{{$t('edit.form.security.allowed')}} {{index + 1}}: </label>
                          <div class="emd-form-group _display_inline">
                            <input class="emd-input" :id="`ip${index}`" type="text" v-on:focusout="form.validateInput" :disabled="disabled" v-model="hosts[index]" required>
                            <button class="emd-btn _color_danger _type_text" @click="removeIPField(index)" type="button" :disabled="disabled">{{$t('edit.form.security.delete')}}</button>
                          </div>
                        </div>
                      </div>
                      <div v-if="hosts.length === 0" class="emd-chunk">
                        <p>{{$t('edit.form.security.none')}}</p>
                      </div>

                      <!--<div class="emd-chunk">
                        <label class="emd-label" for="ip3">IP (n):</label>
                        <div class="emd-form-group _display_inline">
                          <input class="emd-input" id="ip" type="text" :disabled="disabled">
                          <button class="emd-btn _color_danger _type_text" :disabled="disabled">cancelar</button>
                          <button class="emd-btn _color_secondary" :disabled="disabled">salvar</button>
                        </div>
                      </div>-->

                    </div>
                  </div>

                </fieldset>
                <fieldset>
                  <div class="emd-flex _justify_space-between" v-show="!disabled">
                    <div class="emd-flex-item">
                      <button class="emd-btn _color_secondary _type_text" type="button" :disabled="disabled" @click="addIPField">{{$t('edit.form.security.add')}}</button>
                    </div>
                    <div class="emd-flex-item">
                      <div class="emd-flex">
                        <div class="emd-flex-item">
                          <button class="emd-btn _color_primary _type_text" type="button" :disabled="disabledCancel" @click="disabled = !disabled">{{$t('edit.cancel')}}</button>
                        </div>
                        <div class="emd-flex-item">
                          <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid">{{$t('edit.save')}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorList from '@/components/project/ErrorList.vue'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import form from '@/plugins/form.js'

export default {
  name: 'ApplicationSecurity',
  components: {
    ErrorList,
    EmdBoxHeader
  },
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    hosts () {
      if (this.body.hosts === undefined) {
        const security = this.$store.state.application.detail.security
        const hosts = security ? security.hosts : []
        this.body.hosts = hosts
      }
      return this.body.hosts
    }
  },
  data () {
    return {
      disabled: true,
      disabledCancel: false,
      formIsValid: true,
      body: {
        hosts: undefined
      },
      form: form,
      errors: []
    }
  },
  methods: {
    addIPField () {
      this.body.hosts.push('')
    },
    removeIPField (index) {
      this.body.hosts.splice(index, 1)
    },
    displayFeedback () {
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    saveSecurity (e) {
      const elements = [...e.target.elements]
      const invalidElements = elements.filter(element => element.willValidate).filter(element => !element.checkValidity())
      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        this.disabledCancel = true
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('UPDATE_SECURITY', this.body)
          .then(response => {
            this.errors = []
            this.disabled = true
            this.disabledCancel = false
            this.displayFeedback()
            submitButton.classList.remove('_state_loading')
          })
          .catch(response => {
            submitButton.classList.remove('_state_loading')
            this.disabledCancel = false
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      } else {
        invalidElements.forEach(element => {
          form.addInputError(element)
        })
      }
    }
  },
  updated () {
    this.formIsValid = this.$refs.formSecurity.checkValidity()
  }
}
</script>
<style scoped>
.emd-box._state_loading {
  height: 300px;
  background-repeat: no-repeat;
  background-image:
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4);
  background-size:
    15% 25px,
    8% 20px,
    48% 39px,
    48% 39px,
    8% 20px;
  background-position:
    1.59% 9.35%,
    1.59% 31%,
    3% 44%,
    2.75% 82%,
    1.59% 66.5%;
  opacity: 1;
  animation: opacity 1s infinite ease-in;
}
</style>
